export default {"src":"/_next/static/media/check.4c3b7545.svg","height":20,"width":20};